import { THEME } from 'styles/themes';

export const colors = THEME.Coffee.colors ?? {};

export const typography = THEME.Coffee.typography ?? {};

export const options = THEME.Coffee?.options ?? {};
